const translations = {
    "regionMap": "Mapa {{regionType}} {{region}} z zaznaczonymi granicami administracyjnymi. Serwis umożliwia tworzenie własnych map z własnoręcznie zdefiniowanymi lokalizacjami lub wybranymi obiektami z kategorii Usługi, lub Wypoczynek i wykorzystanie tych map we własnym zakresie (np. poprzez osadzenie ich na własnej stronie internetowej lub udostępnienie innym osobom poprzez pocztę, lub komunikator internetowy).",
    "regionMap.regionType.region": "regionu",
    "regionMap.regionType.city": "miejscowości"
};

export default translations;